import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=2273ff8e&scoped=true"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=2273ff8e&prod&scoped=true&lang=css"
import style1 from "./PrivacyPolicy.vue?vue&type=style&index=1&id=2273ff8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273ff8e",
  null
  
)

export default component.exports